module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "credits"
  }, [_h('div', {
    staticClass: "credits__bar"
  }, [_h('div', {
    staticClass: "credits__bar-text"
  }, ["crédits et ", _h('div', ["remerciements"])])]), " ", _h('div', {
    staticClass: "credits__content"
  }, [_h('div', {
    staticClass: "credits__content-title"
  }, ["remerciements"]), " ", _h('div', {
    staticClass: "credits__content-text"
  }, ["Nous tenons à remercier en premier lieu les parents qui nous ont permis de filmer leurs enfants dans le cadre de notre projet. Un grand merci à M. Pumir et son fils Balthazar, Mme Boudisseau et son fils Jean, et à Mme Gossioux et son fils Gabriel."]), " ", _h('div', {
    staticClass: "credits__content-title"
  }, ["crédits audio"]), " ", _h('div', {
    staticClass: "credits__content-text"
  }, ["Joe Hisaishi - Castle in the Sky Theme utilisé dans le cadre de l’expérience vidéo."]), " ", _h('div', {
    staticClass: "credits__content-title"
  }, ["crédits vidéo"]), " ", _h('div', {
    staticClass: "credits__content-text"
  }, ["Les témoignages vidéos utilisés dans les pages « Témoignages » proviennent de l’association Love Comes First. L’utilisation de ces vidéos est uniquement destinée à un cadre de projet scolaire. Ces témoignages ne sont en aucun cas utilisés à des fins commerciales."])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-740254c3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Credits.vue
// module id = 55
// module chunks = 1